import {
  buildHttpResponse,
  buildMultipartHttpResponse,
  HttpMethod,
} from "./Network_utility";
import { ChartRecord, ReChartData } from "../models/chart_model";
import { AuctionChartData } from "../models/auction";
import { ApiResponse } from "../models/api_res";
import DmrcLoad, { DmrcForecastedLoad } from "../models/dmrc";
import {
  GasConsumptionData,
  ProductionData,
  LNGImportData,
  PowerStationData,
} from "../models/gas";
import { PowerGeneration } from "../models/power_generation";
import {
  getFiscalYear,
  getMonthFromDate,
  getMonthYear,
  GetNumberOfDaysInMonth,
  getQuarter,
  getYearFromDate,
  getDayFromDate,
  fillMissingDataByDateIndex,
} from "../extensions/date";
import {
  convertToRajasthanGenData,
  HarayanaDailyForecastData,
  HarayanaDailyPeakData,
  HarayanaDiscomData,
  HarayanaMonthlyForecastData,
  HarayanaMonthlyPeakData,
  HarayanaWeatherData,
  HaryanaGnaTgna,
  HaryanaIsgs,
  HaryanaRemc,
  RajashtanRrvpn,
  RajasthanCollective,
  RajasthanDiscomData,
  RajasthanDiscomDrawal,
  RajasthanGenData,
  RajasthanGnaTgna,
  RajasthanIsgs,
  RajasthanUploadFile,
  RajBankingData,
  RajGenParams,
  RajGenProfile,
  RajMappings,
  RajProcurement,
  RajProcurementRecord,
  RajSurplusDeficitData,
  RajTamData,
  ReEnergyData,
} from "../models/rajasthan";
import {
  GridcoDiscomData,
  gridcoIsgs,
  GridoIsgs,
  IntrastateGen,
} from "../models/gridco";
import { titleCase } from "../extensions/extension";
import { TradersData } from "../models/commonTraders";
import {
  HaryanaYearlyProcurementData,
  HaryanaMonthlyProcurementData,
  HaryanaData,
} from "../models/haryana";
import { sub } from "date-fns";
import { sl } from "date-fns/locale";
import { ExchangeMetrics, GetCollectiveMetricsParams } from "../models/metrics";
import {
  AgentEvent,
  ThumbsFeedbackResponse,
  ThumbsFeedbackResult,
} from "../models/agent";
import { GenerationData } from "../models/generationData";
import { BuyerSellerParams, BuyerSellerResponse } from "../models/buyerSeller";
import { PriceAnalysisData, PriceAnalysisParams } from "../models/priceAnalysis";
import { ConsumptionData } from "../models/consumption";
import { ExchangeAnalysisData, ExchangeAnalysisParams } from "../pages/Hppc/NewExchnage/Tabs/Overview";

const API_BASE =
  process.env.REACT_APP_API_BASE || "https://gnai-agent.gna.energy";

export async function login(email: string): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/login/",
    method: HttpMethod.POST,
    body: {
      email: email,
    },
  });
  return response as ApiResponse;
}

export async function verifyOtp(
  email: string,
  otp: string
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/verify_otp/",
    method: HttpMethod.POST,
    body: {
      email: email,
      otp: otp,
    },
  });
  return response as ApiResponse;
}

export async function checkAccess(accessKey: string): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/check_access/",
    method: HttpMethod.POST,
    body: {
      access_key: accessKey,
    },
  });
  return response as ApiResponse;
}

export async function getSessionValidity(): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/get_session_validity/",
    method: HttpMethod.GET,
  });
  return response as ApiResponse;
}

export async function fetchExchangeSlotData({
  exchange,
  product,
  slot,
  date,
}: {
  exchange: string;
  product: string;
  slot: string;
  date: string;
}) {
  console.log("fetchExchangeSlotData", exchange, product, slot, date);
  const response = await buildHttpResponse({
    endPoint: "data/getTopBuySellData/",
    method: HttpMethod.POST,
    body: {
      exchanges: [exchange],
      products: [product],
      time_slots: [slot],
      start_date: date,
      end_date: date,
    },
  });
  return response;
}

export async function fetchExchangeComparisonData(body: any) {
  const response = await buildHttpResponse({
    endPoint: "data/multipleDateRangeExchangeData/",
    method: HttpMethod.POST,
    body: body,
  });
  return response;
}

export async function fetchAllExchangeData(
  start_date: string,
  end_date: string
) {
  const response = await buildHttpResponse({
    endPoint: `data/getData?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getEntityComparisont({
  entityid,
  exchange,
  startDate,
  endDate,
}: {
  entityid: number;
  exchange: string;
  startDate: string;
  endDate: string;
}): Promise<ReChartData[]> {
  const response = await fetch(
    "https://api-data.gna.energy/data/getSlotWiseAggregatedEntityData/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // {
      //     "start_date": "2024-01-01",
      //     "end_date": "2024-12-31",
      //     "exchange": "IEX",
      //     "entitity_id": 3027
      // }
      body: JSON.stringify({
        start_date: startDate,
        end_date: endDate,
        exchange: exchange,
        entitity_id: entityid,
      }),
    }
  );
  // body: {
  //     'start_date': startDate,
  //     'end_date': endDate,
  //     'exchange': exchange,
  //     'entity_id': entityid
  // }
  const data = await response.json();

  return data.data as any;
}

export async function getEntitys() {
  const response = await fetch("https://api-data.gna.energy/data/getEntitys", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data: {
    data: { id: number; name: string }[];
  } = await response.json();

  const res = data.data.map((d) => {
    return {
      value: d.id,
      name: d.name,
    };
  });
  return res;
}

const fetchLatestAggregatedDayData = async () => {
  try {
    const response = await buildHttpResponse({
      endPoint: "data/latest-aggregated-day-data/",
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Error fetching data");
  }
};

export default fetchLatestAggregatedDayData;

export async function fetchPSPData() {
  const response = await buildHttpResponse({
    endPoint: "data/power_supply_api",
    method: HttpMethod.POST,
  });
  return response;
}

export async function fetchDailyAuctionData({
  start_date,
  end_date,
  exchange,
  entity_id,
}: {
  start_date: string;
  end_date: string;
  exchange?: string;
  entity_id?: number;
}): Promise<AuctionChartData[]> {
  const response = await buildHttpResponse({
    endPoint: `data/auction-daily-api?start_date=${start_date}&end_date=${end_date}&exchange_type=${exchange}`,
    method: HttpMethod.GET,
  });
  return response as AuctionChartData[];
}

export async function fetchMonthlyAuctionData({
  start_date,
  end_date,
  exchange,
  entity_id,
}: {
  start_date: string;
  end_date: string;
  exchange?: string;
  entity_id?: number;
}): Promise<AuctionChartData[]> {
  const response = await buildHttpResponse({
    endPoint: `data/auction-monthly-api?start_date=${start_date}&end_date=${end_date}&exchange_type=${exchange}`,
    method: HttpMethod.GET,
  });
  return response as AuctionChartData[];
}

export async function fetchSnapshots(
  start_date: string,
  end_date: string
): Promise<ChartRecord[]> {
  const response = await buildHttpResponse({
    endPoint: `data/getSnapshots?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
  });
  return response as ChartRecord[];
}

// Function to fetch TAM data
export async function fetchTamData(
  start_date: string,
  end_date: string
): Promise<ChartRecord[]> {
  const response = await buildHttpResponse({
    endPoint: `data/getTamData?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
  });
  return response as ChartRecord[];
}

export async function fetchAuctionData({
  startDate,
  endDate,
}: {
  startDate: String;
  endDate: String;
}) {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/search-auction/?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching auctions:", error);
    return [];
  }
}

export async function fetchDamAnalysisData({
  startDate,
  endDate,
  entity,
}: {
  startDate: String;
  endDate: String;
  entity: string;
}) {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/getDamAnalysisData?start_date=${startDate}&end_date=${endDate}&entity=${entity}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching dam analysis:", error);
    return [];
  }
}

export async function getDmrcLoadData({
  startDate,
  endDate,
  entity,
}: {
  startDate: String;
  endDate: String;
  entity?: string;
}): Promise<DmrcLoad[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `dmrc/getDmrcData?start_date=${startDate}&end_date=${endDate}&entity=${entity}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching dam analysis:", error);
    return [];
  }
}
export async function getDmrcForecastLoadData({
  startDate,
  endDate,
  entity,
}: {
  startDate: String;
  endDate: String;
  entity?: string;
}): Promise<DmrcForecastedLoad[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `dmrc/getDmrForecastcData?start_date=${startDate}&end_date=${endDate}&entity=${entity}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching dam analysis:", error);
    return [];
  }
}
export async function dmrcChatGptRes({
  query,
  thread_token,
}: {
  query: string;
  thread_token: string;
}): Promise<{ sender: String; content: String }> {
  const response = await buildHttpResponse({
    endPoint: `dmrc/handeUserQuery?query=${query}&thread_token=${thread_token}`,
    method: HttpMethod.GET,
  });
  return response;
}

// POST dmrc/create_thread
export async function createThread(): Promise<{ thread_token: string }> {
  const response = await buildHttpResponse({
    endPoint: `dmrc/create_thread`,
    method: HttpMethod.POST,
  });
  return response;
}

export async function getGasConsumptionData({
  startDate,
  endDate,
  sectorName,
}: {
  startDate?: string;
  endDate?: string;
  sectorName?: string;
}): Promise<GasConsumptionData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);
    if (sectorName) queryParams.append("sector_name", sectorName);

    const response = await buildHttpResponse({
      endPoint: `gas/getConsumptionData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response.map((item: GasConsumptionData) => {
      const month = item.month.slice(0, 3);
      const numberOfDays = GetNumberOfDaysInMonth(month, item.year);
      return {
        ...item,
        month: item.month.slice(0, 3) + "`" + item.year.toString().slice(2, 4),
        domestic_consumption_mmscmd: item.domestic_consumption / numberOfDays,
        rlng_consumption_mmscmd: item.rlng_consumption / numberOfDays,
        total_consumption_mmscmd: item.total_consumption / numberOfDays,
        fyear: getFiscalYear(month, item.year),
        quarter:
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_year: item.month + "-" + item.year,
        month_quarter:
          item.month +
          "-" +
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_fyear: item.month + "-" + getFiscalYear(month, item.year),
      };
    });
  } catch (error) {
    console.error("Error fetching consumption data:", error);
    return [];
  }
}

// API to fetch Production Data
export async function getGasProductionData({
  startDate,
  endDate,
  stateName,
}: {
  startDate?: string;
  endDate?: string;
  stateName?: string;
}): Promise<ProductionData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);
    if (stateName) queryParams.append("state_name", stateName);

    const response = await buildHttpResponse({
      endPoint: `gas/getProductionData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response.map((item: ProductionData) => {
      const month = item.month.slice(0, 3);
      const numberOfDays = GetNumberOfDaysInMonth(month, item.year);

      return {
        ...item,
        month: month + "`" + item.year.toString().slice(2, 4),
        state__state_name: item.state__state_name.replace("Off shore", ""),
        month_year: item.month + "-" + item.year,
        value_mmscmd: item.value / numberOfDays,
        quarter:
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_quarter:
          item.month +
          "-" +
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_fyear: item.month + "-" + getFiscalYear(month, item.year),

        fyear: getFiscalYear(month, item.year),
      };
    });
  } catch (error) {
    console.error("Error fetching production data:", error);
    return [];
  }
}

// API to fetch LNG Import Data
export async function getGasLNGImportData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<LNGImportData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);

    const response = await buildHttpResponse({
      endPoint: `gas/getLNGImportData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response.map((item: LNGImportData) => {
      const month = item.month.slice(0, 3);
      const numberOfDays = GetNumberOfDaysInMonth(month, item.year);

      return {
        ...item,
        month: item.month.slice(0, 3) + "`" + item.year.toString().slice(2, 4),
        mmscmd: item.mmscm / numberOfDays,
        rs_mmscm: item.rs_crore / item.mmscm,
        usd_mmscm: item.million_usd / item.mmscm,
        quarter:
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_year: item.month + "-" + item.year,
        month_quarter:
          item.month +
          "-" +
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_fyear: item.month + "-" + getFiscalYear(month, item.year),

        fyear: getFiscalYear(month, item.year),

        inr_mbtu: (item.rs_crore * 10000000) / (item.mmscm * 35314.7),
        usd_mbtu: (item.million_usd * 1000000) / (item.mmscm * 35314.7),
      };
    });
  } catch (error) {
    console.error("Error fetching LNG import data:", error);
    return [];
  }
}

export async function getPowerStationsData({
  state,
  sector,
  month,
  year,
}: {
  state?: string; // state ID (optional)
  sector?: string; // sector ID (optional)
  month?: string; // month (optional)
  year?: string; // year (optional)
}): Promise<PowerStationData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (state) queryParams.append("state", state);
    if (sector) queryParams.append("sector", sector);
    if (month) queryParams.append("month", month);
    if (year) queryParams.append("year", year);

    const response = await buildHttpResponse({
      endPoint: `gas/getPowerStationsData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching power station data:", error);
    return [];
  }
}

export async function getPowerGenerationData({
  start_date,
  end_date,
}: {
  start_date: string;
  end_date: string;
}): Promise<PowerGeneration[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/getGenerationData?start_date=${start_date}&end_date=${end_date}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching power generation data:", error);
    return [];
  }
}

export async function getRajasthanDiscomDrawlData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawal?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    const uniqueDates = Array.from(new Set(response.map((item) => item[0])));
    return response.map((item) => {
      // Map discom codes to names
      const discomMap: Record<string, string> = {
        JDVVNL: "Jodhpur",
        JVVNL: "Jaipur",
        AVVNL: "Ajmer",
      };
      return {
        dateIndex: (uniqueDates.indexOf(item[0]) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        date: item[0],
        month: getMonthFromDate(item[0]),
        block: item[1],
        area: item[2],
        mw: item[3],
        lu: item[3] / 400,
        discom: discomMap[item[4]] || item[4],
        division: item[6],
        district: item[5],
        mwh: item[3] / 4,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getDemoRajasthanDiscomDrawlData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawal?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive uniques
    const uniqueDates = Array.from(new Set(response.map((item) => item[0])));
    const uniqueAreas = Array.from(new Set(response.map((item) => item[2])));
    const uniqueDistricts = Array.from(
      new Set(response.map((item) => item[5]))
    );
    const uniqueDivisions = Array.from(
      new Set(response.map((item) => item[6]))
    );

    // build generic maps
    const discomMap: Record<string, string> = {
      JDVVNL: "Discom 1",
      JVVNL: "Discom 2",
      AVVNL: "Discom 3",
    };
    const areaMap: Record<string, string> = {};
    uniqueAreas.forEach((a, i) => (areaMap[a] = `Area ${i + 1}`));
    const districtMap: Record<string, string> = {};
    uniqueDistricts.forEach((d, i) => (districtMap[d] = `District ${i + 1}`));
    const divisionMap: Record<string, string> = {};
    uniqueDivisions.forEach((v, i) => (divisionMap[v] = `Division ${i + 1}`));

    return response.map((item) => ({
      dateIndex: (uniqueDates.indexOf(item[0]) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      date: item[0],
      month: getMonthFromDate(item[0]),
      block: item[1],
      area: areaMap[item[2]] || item[2],
      mw: item[3],
      lu: item[3] / 400,
      discom: discomMap[item[4]] || item[4],
      district: districtMap[item[5]] || item[5],
      division: divisionMap[item[6]] || item[6],
      mwh: item[3] / 4,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanDiscomDrawlForecastData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawalForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    const uniqueDates = Array.from(new Set(response.map((item) => item[1])));
    return response.map((item) => {
      // Map discom codes to names
      const discomMap: Record<string, string> = {
        JDVVNL: "Jodhpur",
        JVVNL: "Jaipur",
        AVVNL: "Ajmer",
      };
      return {
        dateIndex: (uniqueDates.indexOf(item[1]) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        date: item[1],
        month: getMonthFromDate(item[1]),
        block: item[2],
        area: item[3],
        mw: item[4],
        lu: item[4] / 400,
        discom: discomMap[item[5]] || item[5],
        division: item[6],
        district: item[7],
        mwh: 0,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getDemoRajasthanDiscomDrawlForecastData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawalForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive uniques
    const uniqueDates = Array.from(new Set(response.map((item) => item[1])));
    const uniqueAreas = Array.from(new Set(response.map((item) => item[3])));
    const uniqueDiscoms = Array.from(new Set(response.map((item) => item[5])));
    const uniqueDivisions = Array.from(
      new Set(response.map((item) => item[6]))
    );
    const uniqueDistricts = Array.from(
      new Set(response.map((item) => item[7]))
    );

    // build generic maps
    const discomMap: Record<string, string> = {};
    uniqueDiscoms.forEach((d, i) => (discomMap[d] = `Discom ${i + 1}`));

    const areaMap: Record<string, string> = {};
    uniqueAreas.forEach((a, i) => (areaMap[a] = `Area ${i + 1}`));

    const divisionMap: Record<string, string> = {};
    uniqueDivisions.forEach((v, i) => (divisionMap[v] = `Division ${i + 1}`));

    const districtMap: Record<string, string> = {};
    uniqueDistricts.forEach((d, i) => (districtMap[d] = `District ${i + 1}`));

    return response.map((item) => ({
      dateIndex: (uniqueDates.indexOf(item[1]) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      date: item[1],
      month: getMonthFromDate(item[1]),
      block: item[2],
      area: areaMap[item[3]] || item[3],
      mw: item[4],
      lu: item[4] / 400,
      discom: discomMap[item[5]] || item[5],
      division: divisionMap[item[6]] || item[6],
      district: districtMap[item[7]] || item[7],
      mwh: 0,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanAreaForecastData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanAreaForecastData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    console.log("====================================");
    console.log(response);
    return response.map((item) => {
      return {
        date: item[1],
        month: getMonthFromDate(item[1]),
        block: item[2],
        area: item[3],
        mw: item[4],
        discom: item[5],
        division: item[6],
        district: item[7],
        mwh: 0,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanDiscomData(
  startDate: string,
  endDate: string
): Promise<RajasthanDiscomData[]> {
  try {
    const response: Promise<RajasthanDiscomData[]> = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data: RajasthanDiscomData[] = await response;

    // Generate all dates in the requested range for proper dateIndex calculation
    const allDatesInRange: string[] = [];
    const currentDate = new Date(startDate);
    const endDateObj = new Date(endDate);

    while (currentDate <= endDateObj) {
      allDatesInRange.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Transform the data first with correct dateIndex based on full range
    const transformedData = data.map((item) => {
      const dateIndex =
        (allDatesInRange.indexOf(item.date) + 1).toString() + " Day";
      return {
        ...item,
        drawal_mwh: item.drawal_mw / 4,
        drawal_mw: item.drawal_mw,
        drawal_lu: item.drawal_mw / 400,
        total_mwh: (item.load_shedding_mw + item.drawal_mw) / 4,
        total_mw: item.load_shedding_mw + item.drawal_mw,
        schedule_mw: item.schedule_mw,
        schedule_mwh: item.schedule_mw / 4,
        schedule_lu: item.schedule_mw / 400,
        load_shedding_mwh: item.load_shedding_mw / 4,
        load_shedding_lu: item.load_shedding_mw / 400,
        dateIndex: dateIndex,
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
      };
    });

    // Extract unique discoms from the data
    const uniqueDiscoms: string[] = Array.from(
      new Set(transformedData.map((item: any) => item.discom))
    );

    // Fill missing data based on dateIndex pattern for each discom
    const filledData = fillMissingDataByDateIndex(
      transformedData,
      startDate,
      endDate,
      uniqueDiscoms, // Use actual discoms from data
      (date, block, dateIndex, discom) =>
        ({
          date,
          block,
          dateIndex,
          dates: `${startDate} to ${endDate}`,
          month: getMonthFromDate(date),
          discom: discom || "",
          drawal_mw: 0,
          drawal_mwh: 0,
          drawal_lu: 0,
          schedule_mw: 0,
          schedule_mwh: 0,
          schedule_lu: 0,
          load_shedding_mw: 0,
          load_shedding_mwh: 0,
          load_shedding_lu: 0,
          total_mw: 0,
          total_mwh: 0,
        } as any)
    );

    return filledData;
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getDemoRajasthanDiscomData(
  startDate: string,
  endDate: string
): Promise<RajasthanDiscomData[]> {
  try {
    const response: Promise<RajasthanDiscomData[]> = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data = await response;
    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));

    // Map discom codes to demo names
    const discomMap: Record<string, string> = {
      JDVVNL: "Discom 1",
      JVVNL: "Discom 2",
      AVVNL: "Discom 3",
    };

    return (await response).map((item) => {
      return {
        ...item,
        discom: discomMap[item.discom] || item.discom, // Apply the mapping
        drawal_mwh: item.drawal_mw / 4,
        drawal_mw: item.drawal_mw,
        drawal_lu: item.drawal_mw / 400,
        total_mwh: (item.load_shedding_mw + item.drawal_mw) / 4,
        total_mw: item.load_shedding_mw + item.drawal_mw,
        schedule_mw: item.schedule_mw,
        schedule_mwh: item.schedule_mw / 4,
        schedule_lu: item.schedule_mw / 400,
        load_shedding_mwh: item.load_shedding_mw / 4,
        load_shedding_lu: item.load_shedding_mw / 400,
        dateIndex:
          (
            uniqueDates.indexOf((item as { date: string }).date) + 1
          ).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanForecastDiscomData(
  startDate: string,
  endDate: string,
  model: string
): Promise<RajasthanDiscomData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getDiscomForecast?start_date=${startDate}&end_date=${endDate}&model=${model}`,
      method: HttpMethod.GET,
      noCache: true,
    });
    const data = (await response) as RajasthanDiscomData[];

    // Generate all dates in the requested range for proper dateIndex calculation
    const allDatesInRange: string[] = [];
    const currentDate = new Date(startDate);
    const endDateObj = new Date(endDate);

    while (currentDate <= endDateObj) {
      allDatesInRange.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    const groupedByForecastType = data.reduce(
      (
        acc: Record<string, RajasthanDiscomData[]>,
        item: RajasthanDiscomData & { forcast_type?: string | number }
      ) => {
        const key = `${item.forcast_type ?? "UNKNOWN"}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      },
      {} as Record<string, RajasthanDiscomData[]>
    );

    const processForecastTypeData = (
      items: RajasthanDiscomData[],
      forecastType: string
    ) => {
      type RajasthanForecastRow = RajasthanDiscomData & { dateIndex: string };

      const transformedData: RajasthanForecastRow[] = items.map(
        (item: RajasthanDiscomData) => {
        const dateIndex =
          (allDatesInRange.indexOf(item.date) + 1).toString() + " Day";
        return {
          ...item,
          discom: item.discom,
          drawal_mwh: (item.drawal_mw + 0) / 4,
          drawal_mw: item.drawal_mw + 0,
          drawal_lu: (item.drawal_mw + 0) / 400,
          total_mwh: item.drawal_mw / 4,
          total_mw: item.drawal_mw,
          total_lu: item.drawal_mw / 400,
          schedule_mwh: item.schedule_mw / 4,
          schedule_mw: item.schedule_mw,
          schedule_lu: item.schedule_mw / 400,
          load_shedding_mwh: 0,
          load_shedding_lu: 0,
            dateIndex: dateIndex,
            dates: `${startDate} to ${endDate}`,
            month: getMonthFromDate(item.date),
            forcast_type: forecastType,
          };
        }
      );

      const uniqueDiscoms: string[] = Array.from(
        new Set(transformedData.map((item: any) => item.discom))
      );

      return fillMissingDataByDateIndex(
        transformedData,
        startDate,
        endDate,
        uniqueDiscoms,
        (date, block, dateIndex, discom) =>
          ({
            date,
            block,
            dateIndex,
            dates: `${startDate} to ${endDate}`,
            month: getMonthFromDate(date),
            discom: discom || "",
            drawal_mw: 0,
            drawal_mwh: 0,
            drawal_lu: 0,
            schedule_mw: 0,
            schedule_mwh: 0,
            schedule_lu: 0,
            load_shedding_mw: 0,
            load_shedding_mwh: 0,
            load_shedding_lu: 0,
            total_mw: 0,
            total_mwh: 0,
            total_lu: 0,
            forcast_type: forecastType,
          } as RajasthanForecastRow)
      );
    };

    const filledData = (
      Object.entries(groupedByForecastType) as Array<
        [string, RajasthanDiscomData[]]
      >
    ).flatMap(([forecastType, items]) =>
      processForecastTypeData(
        items,
        forecastType || (items[0]?.forcast_type) || "UNKNOWN"
      )
    );

    console.log("🚀 ~ getRajasthanForecastDiscomData ~ filledData:", filledData);
    return filledData;
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getGridcoDiscomData(
  startDate: string,
  endDate: string
): Promise<GridcoDiscomData[]> {
  try {
    const response: Promise<GridcoDiscomData[]> = await buildHttpResponse({
      endPoint: `gridco/getDiscomDataTemp?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    const res = await response;
    const uniqueDates = Array.from(new Set(res.map((item) => item.date)));
    return (await response).map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        drawal_mwh: item.drawal_mw / 4,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

function applyBlockReplacements(
  data: RajasthanDiscomData[]
): RajasthanDiscomData[] {
  const replacementMappings: {
    targetDate: string;
    discom: string;
    blocks: number[];
    sourceDate: string;
  }[] = [
    {
      targetDate: "2024-12-10",
      discom: "Jodhpur",
      blocks: [82],
      sourceDate: "2024-12-09",
    },
    {
      targetDate: "2024-12-10",
      discom: "Ajmer",
      blocks: [82],
      sourceDate: "2024-12-09",
    },
  ];

  const modifiedData = [...data]; // Create a copy to avoid modifying original data

  replacementMappings.forEach(({ targetDate, discom, blocks, sourceDate }) => {
    blocks.forEach((block) => {
      const sourceRecord = data.find(
        (record) =>
          record.date === sourceDate &&
          record.block === block &&
          record.discom === discom
      );

      if (sourceRecord) {
        modifiedData.forEach((record) => {
          if (
            record.date === targetDate &&
            record.block === block &&
            record.discom === discom
          ) {
            record.schedule_mw = sourceRecord.schedule_mw; // Apply the replacement
          }
        });
      }
    });
  });

  return modifiedData;
}

export async function getRajasthanGenerationData(
  startDate: string,
  endDate: string
): Promise<RajasthanGenData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getGenerationData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const uniqueDates = Array.from(
      new Set(response.map((item: any[]) => item[0]))
    );
    return response.map((item: any[]) => {
      const convertedData = convertToRajasthanGenData(item);
      return {
        ...convertedData,
        dateIndex:
          (uniqueDates.indexOf(convertedData.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Generation data:", error);
    return [];
  }
}

export async function getDemoRajasthanGenerationData(
  startDate: string,
  endDate: string
): Promise<RajasthanGenData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getGenerationData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive unique dates & stations
    const uniqueDates = Array.from(
      new Set(response.map((item: any[]) => item[0]))
    );
    const uniqueStations = Array.from(
      new Set(
        response.map((item: any[]) => convertToRajasthanGenData(item).station)
      )
    );
    const stationMap: Record<string, string> = {};
    uniqueStations.forEach(
      (st, i) => (stationMap[st as string] = `Station ${i + 1}`)
    );

    return response.map((item: any[]) => {
      const convertedData = convertToRajasthanGenData(item);
      return {
        ...convertedData,
        state: "Demo State",
        station: stationMap[convertedData.station] || convertedData.station,
        dateIndex:
          (uniqueDates.indexOf(convertedData.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Generation data:", error);
    return [];
  }
}

export async function getRajasthanIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanIsgsData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    })) as RajasthanIsgs[];

    const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
    return response.map((item) => {
      return {
        ...item,
        value_mwh: item.value_mw / 4,
        station: item.from_utility__name,
        month: getMonthFromDate(item.date),
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        from_gen__generation_source: item.generator_source,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getDemoRajasthanIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanIsgsData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    })) as RajasthanIsgs[];

    // derive unique dates, states & stations
    const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
    const uniqueStates: string[] = Array.from(
      new Set(response.map((item: any) => item.state))
    );
    const uniqueStations = Array.from(
      new Set(response.map((item) => item.from_utility__name))
    );

    // build generic maps
    const stateMap: Record<string, string> = {};
    uniqueStates.forEach((s, i) => (stateMap[s] = `State ${i + 1}`));

    const stationMap: Record<string, string> = {};
    uniqueStations.forEach((s, i) => (stationMap[s] = `Station ${i + 1}`));

    return response.map((item) => ({
      ...item,
      state: stateMap[item.state] || item.state,
      station: stationMap[item.from_utility__name] || item.from_utility__name,
      from_utility__name:
        stationMap[item.from_utility__name] || item.from_utility__name,
      value_mwh: item.value_mw / 4,
      month: getMonthFromDate(item.date),
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      from_gen__generation_source: item.generator_source,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getRajasthanIsgsIntervalData({
  startDate,
  endDate,
  interval = "date",
}: {
  startDate: string;
  endDate: string;
  interval?: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/isgs-data-interval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
      method: HttpMethod.GET,
    });
    // const mappings: RajMappings = await buildHttpResponse({
    //   endPoint: "rajasthan/getMappings",
    //   method: HttpMethod.GET,
    // });

    // Calculate uniqueDates from the response
    const uniqueDates = Array.from(
      new Set(response.map((item: any) => item.date))
    );

    return response.map((item: any) => {
      return {
        ...item,
        from_gen__generation_source: item.generator_source,
        from_state: item.state,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Interval ISGS Data:", error);
    return [];
  }
}

export async function getDemoRajasthanIsgsIntervalData({
  startDate,
  endDate,
  interval = "date",
}: {
  startDate: string;
  endDate: string;
  interval?: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/isgs-data-interval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
      method: HttpMethod.GET,
    });

    // calculate uniques
    const uniqueDates = Array.from(
      new Set(response.map((item: any) => item.date))
    );
    const uniqueStates: string[] = Array.from(
      new Set(response.map((item: any) => item.state))
    );

    // derive unique station names and build a generic map
    const uniqueStations: string[] = Array.from(
      new Set(response.map((item: any) => item.from_utility__name))
    );
    const stationMap: Record<string, string> = {};
    uniqueStations.forEach((st, i) => {
      stationMap[st] = `Station ${i + 1}`;
    });

    // build state map
    const stateMap: Record<string, string> = {};
    uniqueStates.forEach((s, i) => {
      stateMap[s] = `State ${i + 1}`;
    });

    return response.map((item: any) => {
      return {
        ...item,
        state: stateMap[item.state] || item.state,
        from_state: stateMap[item.state] || item.state,
        station: stationMap[item.from_utility__name] || item.from_utility__name,
        from_utility__name:
          stationMap[item.from_utility__name] || item.from_utility__name,
        from_gen__generation_source: item.generator_source,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Interval ISGS Data:", error);
    return [];
  }
}

export async function getRajasthanCollectiveData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanCollective[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getCollectiveData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Rajasthan Collective Data:", error);
    return [];
  }
}

export async function getGridcoCollectiveData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanCollective[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `gridco/getCollective?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response.map((item: any) => {
      return {
        ...item,
        time_slot: item.slot,
        wt_mcp_rs_kwh: item.rate,
        cost: ((item.rate * item.value_mw) / 4) * 1000,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Collective Data:", error);
    return [];
  }
}

export async function getGnaTgnaData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanGnaTgna[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getGnaTgnaData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response.map((item: { slot: any }) => {
      return {
        ...item,
        time_block: item.slot,
      };
    });
  } catch (error) {
    console.error("Error fetching GnaTgna data:", error);
    return [];
  }
}

export async function getDemoGnaTgnaData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanGnaTgna[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getGnaTgnaData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive uniques for each field
    const uniqueFromStates = Array.from(
      new Set(response.map((item) => item.from_state__name))
    );
    const uniqueFromEntityStates = Array.from(
      new Set(response.map((item) => item.from_utility__entity_state__name))
    );
    const uniqueFromUtilities = Array.from(
      new Set(response.map((item) => item.from_utility__name))
    );
    const uniqueToStates = Array.from(
      new Set(response.map((item) => item.to_state__name))
    );
    const uniqueToUtilities = Array.from(
      new Set(response.map((item) => item.to_utility__name))
    );
    const uniqueTraders = Array.from(
      new Set(response.map((item) => item.trader__name))
    );

    // build generic maps
    const fromStateMap: Record<string, string> = {};
    uniqueFromStates.forEach((v, i) => {
      fromStateMap[v] = `State ${i + 1}`;
    });

    const fromEntityStateMap: Record<string, string> = {};
    uniqueFromEntityStates.forEach((v, i) => {
      fromEntityStateMap[v] = `State ${i + 1}`;
    });

    const fromUtilityMap: Record<string, string> = {};
    uniqueFromUtilities.forEach((v, i) => {
      fromUtilityMap[v] = `Utility ${i + 1}`;
    });

    const toStateMap: Record<string, string> = {};
    uniqueToStates.forEach((v, i) => {
      toStateMap[v] = `State ${i + 1}`;
    });

    const toUtilityMap: Record<string, string> = {};
    uniqueToUtilities.forEach((v, i) => {
      toUtilityMap[v] = `Utility ${i + 1}`;
    });

    const traderMap: Record<string, string> = {};
    uniqueTraders.forEach((v, i) => {
      traderMap[v] = `Trader ${i + 1}`;
    });

    return response.map((item) => ({
      ...item,
      time_block: item.slot,
      from_state__name:
        fromStateMap[item.from_state__name] || item.from_state__name,
      from_utility__entity_state__name:
        fromEntityStateMap[item.from_utility__entity_state__name] ||
        item.from_utility__entity_state__name,
      from_utility__name:
        fromUtilityMap[item.from_utility__name] || item.from_utility__name,
      to_state__name: toStateMap[item.to_state__name] || item.to_state__name,
      to_utility__name:
        toUtilityMap[item.to_utility__name] || item.to_utility__name,
      trader__name: traderMap[item.trader__name] || item.trader__name,
    }));
  } catch (error) {
    console.error("Error fetching GnaTgna data:", error);
    return [];
  }
}
export async function createRajProcurementRecord(
  formData: any
): Promise<string> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/procurement/create`,
      method: HttpMethod.POST,
      body: formData,
    });
    return response.message;
  } catch (error) {
    console.error("Error fetching GnaTgna data:", error);
    return "Inserting error";
  }
}

export async function getRajFileTypes(): Promise<string[]> {
  const response = await buildHttpResponse({
    endPoint: "rajasthan/get-file-types",
    method: HttpMethod.GET,
  });
  return response;
}

export async function uploadRajFile(formData: any): Promise<string> {
  const response = await buildMultipartHttpResponse({
    endPoint: "rajasthan/upload-file", // Replace with your endpoint
    method: HttpMethod.POST,
    formData,
  });
  return response.message;
}

export async function uploadGridcoNetScheduleFile(formData: any): Promise<{
  automation_files: Array<{ file_url: string }>;
}> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/automation",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

// export async function uploadGridcoNetScheduleFile(formData: any): Promise<{
//   files: Array<{ file_url: string }>;
// }> {
//   const response = await buildMultipartHttpResponse({
//     endPoint: "gridco/getGridcoAutomationFile",
//     method: HttpMethod.POST,
//     formData,
//   });
//   return response;
// }

export async function getRajReData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<ReEnergyData[]> {
  const response: ReEnergyData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRenewableGeneration?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });

  const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
  return response.map((item) => {
    return {
      ...item,
      value_mwh: item.value_mw / 4,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      energy_type: item.energy_type__name,
      time_block: item.slot,
    };
  });
}
export async function getProcurementRecord(
  page: any,
  perpage: any
): Promise<RajProcurementRecord[]> {
  try {
    const response = await fetch(
      `https://datahub.gna.energy/rajasthan_procurement?page=${page}&per_page=${perpage}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching Procurement Record :", error);
    return [];
  }
}

export async function getRajOperatingPar(): Promise<RajGenParams[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getRajOperatingPar`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Rajasthan Operating Parameters data:", error);
    return [];
  }
}

export async function getRajOutageData(startDate: string, endDate: string) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getMachinePositionDetailed?from_date=${startDate}&to_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getDemoRajOperatingPar(): Promise<RajGenParams[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `rajasthan/getRajOperatingPar`,
      method: HttpMethod.GET,
    })) as RajGenParams[];

    // derive uniques
    const uniqueGenerators = Array.from(
      new Set(response.map((item) => item.generator))
    );

    // build generic map
    const generatorMap: Record<string, string> = {};
    uniqueGenerators.forEach((g, i) => {
      generatorMap[g] = `Generator ${i + 1}`;
    });

    // apply mapping
    return response.map((item) => ({
      ...item,
      generator: generatorMap[item.generator] || item.generator,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan Operating Parameters data:", error);
    return [];
  }
}

export async function getRajFiles(): Promise<RajasthanUploadFile[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getRajUploadedFile`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Rajasthan Files data:", error);
    return [];
  }
}

export async function rajChatGptRes({
  query,
  thread_token,
}: {
  query: string;
  thread_token: string;
}): Promise<{ sender: String; content: String }> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/handeUserQuery?query=${query}&thread_token=${thread_token}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function uploadGridcoFile(formData: any): Promise<string> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/upload_gridco_file", // Replace with your endpoint
    method: HttpMethod.POST,
    formData,
  });
  return response.message;
}

export async function createFileType(name: string): Promise<string> {
  const response = await buildHttpResponse({
    endPoint: "gridco/create_file_type", // Replace with your endpoint
    method: HttpMethod.POST,
    body: { name },
  });
  return response.message;
}

export async function deleteFileType(name: string): Promise<string> {
  const response = await buildHttpResponse({
    endPoint: "gridco/delete_file_type", // Replace with your endpoint
    method: HttpMethod.POST,
    body: { name },
  });
  return response.message;
}
export async function getGridcoUploadedFile(): Promise<string[]> {
  const response = await buildHttpResponse({
    endPoint: "gridco/getGridcoUploadedFile",
    method: HttpMethod.GET,
  });
  return response;
}

export async function getGridcoFileTypes(): Promise<string[]> {
  const response = await buildHttpResponse({
    endPoint: "gridco/get_gridco_file_types",
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajGenProfileData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajGenProfile[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getGenProfileData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}
export async function getRajSurplusData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajSurplusDeficitData[]> {
  const response = await buildHttpResponse({
    endPoint: `/rajasthan/getSurDefProfile?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response.map((item: any) => {
    return {
      ...item,
      block: item.time_block,
    };
  });
}

export async function getSurDefProfile({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajGenProfile[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getSurDefProfile?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajDeep({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajProcurement[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajDeep?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajIntraGen({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajProcurement[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajIntraGen?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajIsgs({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajProcurement[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajIsgs?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getGridcoIntraGen({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<IntrastateGen[]> {
  const response: IntrastateGen[] = await buildHttpResponse({
    endPoint: `gridco/get_intrastate_gen_adjusted_data?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
  return response.map((item) => {
    return {
      ...item,
      generator_type: titleCase(item.generator_type),
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      time_block: item.time_block,
      slot: item.time_block,
    };
  });
}

export async function getRajTamData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajTamData[]> {
  const response: RajTamData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRajNoarData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajNoar({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajTamData[]> {
  const response: RajTamData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRajNoarData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getGridcoIsgs({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<GridoIsgs[]> {
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoIsgsData?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });

  const uniqueDates = Array.from(
    new Set(response.map((item: { date: any }) => item.date))
  );
  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      slot: item.time_block,
      time_block: item.time_block,
    };
  });
}
export async function getGridcoRegen({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<GridoIsgs[]> {
  const response = await buildHttpResponse({
    endPoint: `gridco/get_re_gen_data?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  const uniqueDates = Array.from(
    new Set(response.map((item: { date: any }) => item.date))
  );
  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      time_block: item.slot,
      slot: item.slot,
      discom_name: item.discom__name,
      generator_type: item.generator_type__name,
      ownership: item.ownership__name,
      sub_station: item.sub_station__name,
    };
  });
}

export async function getRajBankingData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajBankingData[]> {
  const response: RajBankingData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRajBankingData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response.map((item) => {
    return {
      ...item,
      mwh: item.mwh,
    };
  });
}

export async function getHaryanaDiscomData(
  startDate: string,
  endDate: string
): Promise<HarayanaDiscomData[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemand?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res;

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));
    return data.map((item: any) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        demand_mw: parseFloat(item.demand_mw.toString()),
        demand_mwh: parseFloat(item.demand_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
        year: getYearFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

// New API function for demand metrics
export async function getHaryanaDemandMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemandMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        time_string: item.time_string,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          item.mode_demand_window_formula.toString()
        ),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Demand Metrics data:", error);
    return [];
  }
}

export async function getHaryanaIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<HaryanaIsgs[]> {
  try {
    const response: Promise<{ data: HaryanaIsgs[] }> = await buildHttpResponse({
      endPoint: `haryana/getIsgs?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item) => {
      return {
        ...item,
        value_mw: parseFloat(item.value_mw.toString()),
        value_mwh: parseFloat(item.value_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getHaryanaGnaTgnaData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<HaryanaGnaTgna[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getOaGnaTgna?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res;
    console.log(data);
    return data.map((item: any) => {
      return {
        ...item,
        value_mw: parseFloat(item.value_mw.toString()),
        value_mwh: parseFloat(item.value_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana ISGS Data:", error);
    return [];
  }
}

export async function getHaryanaRemcData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<HaryanaRemc[]> {
  try {
    const response: Promise<{ data: HaryanaRemc[] }> = await buildHttpResponse({
      endPoint: `haryana/getOaRemc?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item) => {
      return {
        ...item,
        value_mw: parseFloat(item.value_mw.toString()),
        value_mwh: parseFloat(item.value_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getHaryanaYearlyProcurementData(): Promise<
  HaryanaYearlyProcurementData[]
> {
  const response = await buildHttpResponse({
    endPoint: `haryana/getYearlyProcurement`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response.data;
}

export async function getHaryanaMonthlyProcurementData(): Promise<
  HaryanaMonthlyProcurementData[]
> {
  const response = await buildHttpResponse({
    endPoint: `haryana/getMonthlyProcurement`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response.data.map((item: HaryanaMonthlyProcurementData) => {
    return {
      ...item,
      month: getMonthYear({ month: item.month - 1, year: parseInt(item.year) }),
    };
  });
}

export async function getHaryanaForecast(
  startDate: string,
  endDate: string
): Promise<HarayanaDiscomData[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getForcast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res;

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));
    return data.map((item: any) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        
        // Demand fields
        demand_mw: parseFloat(item.demand_mw?.toString() || "0"),
        demand_mwh: parseFloat(item.demand_mw?.toString() || "0") / 4,
        
        // Actual Generation fields
        actual_generation_mw: parseFloat(item.actual_generation?.toString() || "0"),
        actual_generation_mwh: parseFloat(item.actual_generation?.toString() || "0") / 4,
        
        // Surplus/Deficit fields (MW/MWh)
        surplus_deficit_mw: parseFloat(item.surplus_deficit_mw?.toString() || "0"),
        surplus_deficit_mwh: parseFloat(item.surplus_deficit_mw?.toString() || "0") / 4,
        
        surplus_deficit_percentage: parseFloat(item.surplus_deficit_percentage?.toString() || "0"),
        
        // Legacy fields for backward compatibility
        value_mw: parseFloat(item.demand_mw?.toString() || "0"),
        value_mwh: parseFloat(item.demand_mw?.toString() || "0") / 4,
        type__name: "Demand",
        
        time_string: item.time_string,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}


export async function getHaryanaForecastMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemandForecastMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          item.mode_demand_window_formula.toString()
        ),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Forecast Metrics data:", error);
    return [];
  }
}

export async function getHaryanaDailyForecast(
  startDate: string,
  endDate: string
): Promise<HarayanaDailyForecastData[]> {
  try {
    const response: Promise<{ data: HarayanaDailyForecastData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDailyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        demand_mw: parseFloat(item.daily_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_demand_value_mw.toString()),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaMonthlyForecast(
  startDate: string,
  endDate: string
): Promise<HarayanaMonthlyForecastData[]> {
  try {
    const response: Promise<{ data: HarayanaMonthlyForecastData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getMonthlyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    let data = res.data;

    data.sort((a, b) => {
      if (a.year === b.year) {
        return Number(a.month) - Number(b.month);
      }
      return a.year - b.year;
    });

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return data.map((item) => ({
      ...item,
      month: `${monthNames[(item.month as any) - 1]} ${String(item.year).slice(
        2,
        4
      )}`,
      year: parseFloat(item.year.toString()),
      demand_mw: parseFloat(item.peak_mw.toString()),
      average_mw: parseFloat(item.average_mw.toString()),
    }));
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getDailyDemandForecast(
  startDate: string,
  endDate: string
): Promise<HarayanaMonthlyForecastData[]> {
  try {
    const response: Promise<{ data: HarayanaMonthlyForecastData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDailyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });
    const res = await response;
    let data = res.data;

    data.sort((a, b) => {
      if (a.year === b.year) {
        return Number(a.month) - Number(b.month);
      }
      return a.year - b.year;
    });

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return data.map((item) => ({
      ...item,
      month: `${monthNames[(item.month as any) - 1]} ${String(item.year).slice(
        2,
        4
      )}`,
      year: parseFloat(item.year.toString()),
      demand_mw: parseFloat(item.peak_mw.toString()),
      average_mw: parseFloat(item.average_mw.toString()),
    }));
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaMonthlyPeak(
  startDate: string,
  endDate: string
): Promise<HarayanaMonthlyPeakData[]> {
  try {
    const response: Promise<{ data: HarayanaMonthlyPeakData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getMonthlyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    let data = res.data;

    data.sort((a, b) => {
      if (a.year === b.year) {
        return Number(a.month) - Number(b.month);
      }
      return a.year - b.year;
    });

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return data.map((item) => ({
      ...item,
      month: `${monthNames[(item.month as any) - 1]} ${String(item.year).slice(
        2,
        4
      )}`,
      year: parseFloat(item.year.toString()),
      demand_mw: parseFloat(item.peak_mw.toString()),
      average_mw: parseFloat(item.average_mw.toString()),
    }));
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaWeather(
  startDate: string,
  endDate: string
): Promise<HarayanaWeatherData[]> {
  try {
    const response: Promise<{ data: HarayanaWeatherData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getWeatherData?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        month: getMonthFromDate(item.date),
        temperature_c: parseFloat(item.temperature_c.toString()),
        humidity_percent: parseFloat(item.humidity_percent.toString()),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaDailyPeak(
  startDate: string,
  endDate: string
): Promise<HarayanaDailyPeakData[]> {
  try {
    const response: Promise<{ data: HarayanaDailyPeakData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDailyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        peak_mw: parseFloat(item.daily_peak_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_daily_peak_demand_value_mw.toString()),
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString()
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        morning_peak_mw:
          parseFloat(item.formatted_data[1]?.max_demand?.toString()) || 0,
        morning_peak_slot: item.formatted_data[1]?.max_demand_slot || "0",
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

// Monthly Peak API
export async function getHaryanaMonthlyPeakDiscom(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getMonthlyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        average_mw: parseFloat(item.average_mw.toString()),
        peak_mw: parseFloat(item.peak_mw.toString()),
        date_of_peak: item.date_of_peak,
        timeblock_of_peak: item.timeblock_of_peak,
        morning_peak_mw: parseFloat(item.morning_peak_mw.toString()),
        date_of_morning_peak: item.date_of_morning_peak,
        timeblock_of_morning_peak: item.timeblock_of_morning_peak,
        evening_peak_mw: parseFloat(item.evening_peak_mw.toString()),
        date_of_evening_peak: item.date_of_evening_peak,
        timeblock_of_evening_peak: item.timeblock_of_evening_peak,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Monthly Peak data:", error);
    return [];
  }
}

// Forecast Daily Peak API
export async function getHaryanaForecastDailyPeak(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getDailyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        peak_mw: parseFloat(item.daily_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_demand_value_mw.toString()),
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString()
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString()
        ),
        morning_peak_slot: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Forecast Daily Peak data:", error);
    return [];
  }
}

// Forecast Monthly Peak API
export async function getHaryanaForecastMonthlyPeak(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getMonthlyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        average_mw: parseFloat(item.average_mw.toString()),
        peak_mw: parseFloat(item.peak_mw.toString()),
        date_of_peak: item.date_of_peak,
        timeblock_of_peak: item.timeblock_of_peak,
        morning_peak_mw: parseFloat(item.morning_peak_mw.toString()),
        date_of_morning_peak: item.date_of_morning_peak,
        timeblock_of_morning_peak: item.timeblock_of_morning_peak,
        evening_peak_mw: parseFloat(item.evening_peak_mw.toString()),
        date_of_evening_peak: item.date_of_evening_peak,
        timeblock_of_evening_peak: item.timeblock_of_evening_peak,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Forecast Monthly Peak data:", error);
    return [];
  }
}

export async function getXgHaryanaForecast(
  startDate: string,
  endDate: string
): Promise<HarayanaDiscomData[]> {
  try {
    const response: Promise<{ data: HarayanaDiscomData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        demand_mw: parseFloat(item.demand_value_mw.toString()),
        demand_mwh: parseFloat(item.demand_value_mw.toString()) / 4,
        value_mw: parseFloat(item.demand_value_mw.toString()),
        value_mwh: parseFloat(item.demand_value_mw.toString()) / 4,
        type__name: "Demand",

        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

// getGenerationForecastData
export async function getHaryanaGenerationForecastData(
  startDate: string,
  endDate: string
): Promise<HaryanaData[]> {
  const response = await buildHttpResponse({
    endPoint: `haryana/getGenerationForecast?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response.data.map((item: HaryanaData) => {
    return {
      ...item,
      sub_type: item.type__name,

      type__name: "Generation",
    };
  });
}

export async function getExchangeCollectiveData(
  startDate: string,
  endDate: string
) {
  const response = await buildHttpResponse({
    endPoint: `data/getCollectiveData?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response.data.map((item: any): { type: string } & typeof item => {
    return {
      ...item,
      type: "Actual",
      month: getMonthFromDate(item.date),
      slot: item.time_slot,
      wt_mcp_rs_kwh: item.wt_mcp_rs_mwh / 1000,
    };
  });
}

export async function getRajEntity() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/entities`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function getRajTrader() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/traders`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getDemoRajEntity() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/entities`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function getDemoRajTrader() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/traders`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function PostRajTransaction(data: any) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/create/`,
    method: HttpMethod.POST,
    body: data,
  });
  return response;
}
export async function PostBulkRajTransaction(data: any) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transaction/bulk_create`,
    method: HttpMethod.POST,
    body: data,
  });
  return response;
}
export async function getRajTransaction() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function deleteRajTransaction(transaction_id: number) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/${transaction_id}/delete/`,
    method: HttpMethod.DELETE,
  });
  return response;
}
export async function upadteRajTransaction(transaction_id: number, data: any) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/${transaction_id}/update/`,
    method: HttpMethod.PUT,
    body: data,
  });
  return response;
}

export async function getRajSchedulingData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajSchedulingData?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getExchangeCollectiveForecastData(
  startDate: string,
  endDate: string,
  product: string,
  exchange: string
) {
  const response = await buildHttpResponse({
    endPoint: `data/getCollectiveForecast?start_date=${startDate}&end_date=${endDate}&exchange=${exchange}&product=${product}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response.map((item: any): { type: string } & typeof item => {
    return {
      ...item,
      type: "Forecast",
      month: getMonthFromDate(item.date),
      slot: item.time_block,
      wt_mcp_rs_kwh: item.mcp,
    };
  });
}

export async function getRajasthanOutageData(
  startDate: string,
  endDate: string,
  interval = "date"
) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getMachinePositionInterval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
    method: HttpMethod.GET,
  });

  // Get unique dates from the response
  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date))
  );

  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      outage_date: item.date,
      outage_time: item.slot,
    };
  });
}

export async function getPriceForecastIEXDaily(
  startDate: string,
  endDate: string,
  interval = "date"
) {
  const response = await buildHttpResponse({
    endPoint: `data/getDataPriceForecast?start_date=${startDate}&end_date=${endDate}&interval=${interval}&exchange=IEX&product=DAM`,
    method: HttpMethod.GET,
    noCache: true,
  });

  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date))
  );

  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
    };
  });
}

export async function getDemoRajasthanOutageData(
  startDate: string,
  endDate: string,
  interval = "date"
) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getMachinePositionInterval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
    method: HttpMethod.GET,
  });

  // Get unique dates from the response
  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date))
  );

  // derive unique station names and build a generic map
  const uniqueStations: string[] = Array.from(
    new Set<string>(response.map((item: any) => item.station_name as string))
  );
  const stationMap: Record<string, string> = {};
  uniqueStations.forEach((s, i) => {
    stationMap[s] = `Station ${i + 1}`;
  });

  return response.map((item: any) => {
    return {
      ...item,
      // apply station_name mapping
      station_name: stationMap[item.station_name] || item.station_name,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      outage_date: item.date,
      outage_time: item.slot,
    };
  });
}

export async function getCollectiveMetrics({
  startDate,
  endDate,
  exchangeName,
  productName,
  blocks,
}: GetCollectiveMetricsParams): Promise<ExchangeMetrics> {
  // Build query string from parameters.
  let query = `?start_date=${encodeURIComponent(startDate)}`;
  if (endDate) query += `&end_date=${encodeURIComponent(endDate)}`;
  if (exchangeName) {
    // Handle array or string - convert array to comma-separated string
    const exchangeStr = Array.isArray(exchangeName) 
      ? exchangeName.join(',') 
      : exchangeName;
    query += `&exchange_name=${encodeURIComponent(exchangeStr)}`;
  }
  if (productName) {
    // Handle array or string - convert array to comma-separated string
    const productStr = Array.isArray(productName)
      ? productName.join(',')
      : productName;
    query += `&product_name=${encodeURIComponent(productStr)}`;
  }
  if (blocks && blocks.length > 0) {
    const blockStr = blocks.join(",");
    query += `&blocks=${encodeURIComponent(blockStr)}`;
  }
  if (exchangeName) {
    // Handle array or string - convert array to comma-separated string
    const exchangeStr = Array.isArray(exchangeName) 
      ? exchangeName.join(',') 
      : exchangeName;
    query += `&exchange_name=${encodeURIComponent(exchangeStr)}`;
  }
  if (productName) {
    // Handle array or string - convert array to comma-separated string
    const productStr = Array.isArray(productName)
      ? productName.join(',')
      : productName;
    query += `&product_name=${encodeURIComponent(productStr)}`;
  }
  if (blocks && blocks.length > 0) {
    const blockStr = blocks.join(",");
    query += `&blocks=${encodeURIComponent(blockStr)}`;
  }

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `data/getExchangeMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}


export async function getTraderBlockData({
  startDate,
  endDate,
  trader,
  product,
  state_of_buyer,
  state_of_seller,
  name_of_seller,
  name_of_buyer,
  category_of_buyer,
  category_of_seller,
  transaction_type,
}: {
  startDate: string;
  endDate: string;
  product: string;
  trader: string;
  state_of_buyer: string;
  state_of_seller: string;
  name_of_seller: string;
  name_of_buyer: string;
  category_of_buyer: string;
  category_of_seller: string;
  transaction_type: string;
}): Promise<TradersData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/getTradingBlockData`,
      method: HttpMethod.POST,
      body: {
        start_date: startDate,
        end_date: endDate,
        trader,
        product,
        state_of_buyer,
        state_of_seller,
        name_of_seller,
        name_of_buyer,
        category_of_buyer,
        category_of_seller,
        transaction_type,
      },
    });

    return response.results.map((item: any) => {
      return {
        ...item,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Trader Data:", error);
    return [];
  }
}

export async function getGridcoIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<gridcoIsgs[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `gridco/getGridcoIsgsData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    })) as gridcoIsgs[];

    const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
    return response.map((item) => {
      return {
        ...item,
        generator_type: titleCase(item.generator_type),
        time_block: item.slot,
        value_mwh: item.experi_value / 4,
        value_mw: item.experi_value,
        station: item.beneficiery_from,
        expp_value_mw: item.expp_value,
        experi_value_mw: item.experi_value,
        losses_value_mw: item.losses || 0,
        losses_value_mwh: (item.losses || 0) / 4,
        entitlement_value_mw: item.entitlement_value,
        expp_value_mwh: item.expp_value / 4,
        experi_value_mwh: item.experi_value / 4,
        entitlement_value_mwh: item.entitlement_value / 4,
        month: getMonthFromDate(item.date),
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getGridcoMeter(
  startDate: string,
  endDate: string,
  selectedDiscom?: Array<string>
) {
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoMeter?start_date=${startDate}&end_date=${endDate}&discom=${selectedDiscom}`,
    method: HttpMethod.GET,
  });

  // Get unique dates from the response
  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date))
  );

  return response.map((item: any) => {
    return {
      ...item,
      value_mw: item.value_mw || 0,
      value_mwh: item.value_mw / 4,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
    };
  });
}

// Optional Query Parameters:
// page
// Type: Query Parameter
// Format: ?page=2
// Default: 1
// Description: The page number you want to retrieve
// Example: http://your-domain/gpt/sessions/?page=2

export const sendThumbsFeedback = async (
  invocationId: string,
  thumbsUp: boolean
): Promise<ThumbsFeedbackResult> => {
  try {
    // const response = await fetch(`${API_BASE}/gpt/events/thumbs-up/`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     invocation_id: invocationId,
    //     thumbs_up: thumbsUp,
    //   }),
    // });
    const response = await buildHttpResponse({
      endPoint: `https://api-data.gna.energy/gpt/events/thumbs-up/`,
      method: HttpMethod.POST,
      customHeader: {
        Authorization: "fbce857c-f28d-4141-b714-8f4be7f743fe",
      },

      body: {
        invocation_id: invocationId,
        thumbs_up: thumbsUp,
      },
    });

    return response as ThumbsFeedbackResponse;
  } catch (error) {
    return {
      error:
        error instanceof Error ? error.message : "An unexpected error occurred",
    };
  }
};

export async function getAgentEvents(): Promise<AgentEvent[]> {
  const response = await buildHttpResponse({
    endPoint: `https://api-data.gna.energy/gpt/events`,
    customHeader: {
      Authorization: "fbce857c-f28d-4141-b714-8f4be7f743fe",
    },

    method: HttpMethod.GET,
  });
  return response;
}

export async function getLatestForecastDate({
  product,
  exchange,
}: {
  product: string;
  exchange: string;
}) {
  const response = await buildHttpResponse({
    endPoint: `data/getLatestPriceForecastData?product=${product}&exchange=${exchange}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getMonthlyPriceForecast() {
  const response = await buildHttpResponse({
    endPoint: `data/getThreeMonthMonthlyForecastSummary?exchange=IEX&product=DAM`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getLatestDataPriceForecastDate() {
  const response = await buildHttpResponse({
    endPoint: `data/getLatestDataPriceForecastDate`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchRvpnData(
  startdate: string,
  endDate: string
): Promise<RajashtanRrvpn[]> {
  const response: Promise<RajashtanRrvpn[]> = await buildHttpResponse({
    endPoint: `rajasthan/getRajasthanNreb?start_date=${startdate}&end_date=${endDate}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  const data = await response;

  // Generate all dates in the requested range for proper dateIndex calculation
  const allDatesInRange: string[] = [];
  const currentDate = new Date(startdate);
  const endDateObj = new Date(endDate);

  while (currentDate <= endDateObj) {
    allDatesInRange.push(currentDate.toISOString().split("T")[0]);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  // Transform the data first with correct dateIndex based on full range
  const transformedData = data.map((item) => {
    const dateIndex =
      (allDatesInRange.indexOf(item.date) + 1).toString() + " Day";
    return {
      ...item,
      dateIndex: dateIndex,
    };
  });

  // Fill missing data based on dateIndex pattern
  // Create a custom filling function for RVPN data since it uses slot_id instead of block
  // Generate all possible combinations
  const allCombinations: Array<{
    date: string;
    slot_id: number;
    dateIndex: string;
  }> = [];

  allDatesInRange.forEach((date, index) => {
    const dateIndex = `${index + 1} Day`;
    for (let slot_id = 1; slot_id <= 96; slot_id++) {
      allCombinations.push({ date, slot_id, dateIndex });
    }
  });

  // Create a map of existing data
  const existingDataMap = new Map<string, RajashtanRrvpn>();
  transformedData.forEach((item) => {
    const key = `${item.date}-${item.slot_id}`;
    existingDataMap.set(key, item);
  });

  // Fill missing data
  const filledData: RajashtanRrvpn[] = [];

  allCombinations.forEach((combo) => {
    const key = `${combo.date}-${combo.slot_id}`;
    const existingItem = existingDataMap.get(key);

    if (existingItem) {
      filledData.push(existingItem);
    } else {
      filledData.push({
        date: combo.date,
        slot_id: combo.slot_id,
        dateIndex: combo.dateIndex,
        drawal_mw: 0,
      });
    }
  });

  return filledData;
}

export async function getPowerBiEmbedConfig() {
  const response = await buildHttpResponse({
    endPoint: `data/get_embed_config_powerbi/`,
    method: HttpMethod.GET,
  });
  return response;
}

// MOD START POST Session
// MOD Gridco START POST Session
export async function fetchgetModSession(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/startSession?date=${startdate}`,
    method: HttpMethod.POST,
    body: {
      date: startdate,
    },
  });
  return response;
}

export async function getModSession() {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSession`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD Stage data
export async function ModStagePost(stage: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postStage`,
    method: HttpMethod.POST,
    body: {
      stage: stage,
      session: session,
    },
  });
  return response;
}

export async function fetchModGridcoArchive(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getPreviousSession?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModGridcoActivateSession(session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/activateSession`,
    method: HttpMethod.POST,
    body: {
      session: session,
    },
    noCache: true,
  });
  return response;
}

// MOD DAM default data
export async function fetchModDamDefault(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDamDefault?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}
// MOD GDAM default data
export async function fetchModGDamDefault(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getGDamDefault?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD RTM default data
export async function fetchModRtmDefault(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getRtmDefault?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function fetchModDemandDefault(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDemandDefault?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function fetchModGDamData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getGDam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// upload file POST DAM RTM DEMAND
export async function ModDamData(ModDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postDam`,
    method: HttpMethod.POST,
    body: ModDamdata,
  });

  return response as ApiResponse;
}

export async function ModRtmData(ModRtmdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postRtm`,
    method: HttpMethod.POST,
    body: ModRtmdata,
  });

  return response as ApiResponse;
}
export async function ModDemandData(ModDemanddata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postDemand`,
    method: HttpMethod.POST,
    body: ModDemanddata,
  });

  return response as ApiResponse;
}

// MOD Aggregated Load Price Data
export async function ModAggregatedLoadData(
  ModAggregatedData: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postAggregatedLoadPrice`,
    method: HttpMethod.POST,
    body: ModAggregatedData,
  });

  return response as ApiResponse;
}

export async function ModGDamData(ModGDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postGDam`,
    method: HttpMethod.POST,
    noCache: true,
    body: ModGDamdata,
  });

  return response as ApiResponse;
}

// MOD DAM fetch Data
export async function fetchModDamData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModDemandData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDemand?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD RTM fetch Data
export async function fetchModRtmData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getRtm?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// MOD TABLE fetch Data
export async function fetchModTableData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getMOD?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModTableChartData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getMODChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// BID final TABLE fetch Data
export async function fetchModBidTableData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModGridcoUpdateBidData(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function getModGridcoBidSimulationData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// post uploadGridcoModFile

export async function ModBulkUploadFile(formData: any): Promise<{
  automationMod_files: Array<{ file_url: string }>;
}> {
  const response = await buildMultipartHttpResponse({
    endPoint: "mod_gridco/automation",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function ModUpdateData(ModUpdatedata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postMOD`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function CreateBidTable(ModUpdatedata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/createBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function fetchgetBidDownload(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getBidDownload?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as ApiResponse;
}
//Simulator Summary
export async function fetchModSimulationSummary(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorGenChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

//Simulator Station
export async function fetchModSimulationStation(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getData4?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

//Simulator Cost of Power
export async function fetchModSimulationCostPower(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorCostPower?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
//Simulator Sale Revenue (IEX DAM)
export async function fetchModSimulationSaleRevenue(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorSalesRevenue?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchModSimulationTopBuyer(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorGenPrice?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// MOD START POST Session
// MOD Ruvital START POST Session
export async function fetchgetModRuvnlSession(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/startSession?date=${startdate}`,
    method: HttpMethod.POST,
    body: {
      date: startdate,
    },
  });
  return response;
}
export async function getModRuvnlSession() {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSession`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD Stage data
export async function ModRuvnlStagePost(stage: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postStage`,
    method: HttpMethod.POST,
    body: {
      stage: stage,
      session: session,
    },
  });
  return response;
}
// MOD DAM default data
export async function fetchModRuvnlDamDefault(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDamDefault?date=${startdate}`,
    method: HttpMethod.GET,
  });
  return response;
}

// MOD RTM default data
export async function fetchModRuvnlRtmDefault(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getRtmDefault?date=${startdate}`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function fetchModRuvnlDemandDefault(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDemandDefault?date=${startdate}`,
    method: HttpMethod.GET,
  });
  return response;
}
// upload file POST DAM RTM DEMAND
export async function ModRuvnlDamData(ModDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postDam`,
    method: HttpMethod.POST,
    body: ModDamdata,
  });

  return response as ApiResponse;
}

export async function ModRuvnlRtmData(ModRtmdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postRtm`,
    method: HttpMethod.POST,
    body: ModRtmdata,
  });

  return response as ApiResponse;
}
export async function ModRuvnlDemandData(
  ModDemanddata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postDemand`,
    method: HttpMethod.POST,
    body: ModDemanddata,
  });

  return response as ApiResponse;
}

// MOD DAM fetch Data
export async function fetchModRuvnlDamData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlDemandData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDemand?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD RTM fetch Data
export async function fetchModRuvnlRtmData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getRtm?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModRuvnlBulkUploadFile(formData: any): Promise<{
  automationMod_files: Array<{ file_url: string }>;
}> {
  const response = await buildMultipartHttpResponse({
    endPoint: "mod_ruvnl/automation",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function CreateBidRuvnlTable(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/createBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}
export async function fetchModRuvnlTableChartData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getMODChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlTableData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getMOD?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModRuvnlUpdateData(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postMOD`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}
export async function ModRuvnlUpdateBidData(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function fetchModRuvnlBidTableData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlBidDownload(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getBidDownload?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as ApiResponse;
}

export async function fetchModRuvnlSimulationSummary(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorGenChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlSimulationTopBuyer(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorGenPrice?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlSimulationCostPower(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorCostPower?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchModRuvnlSimulationSaleRevenue(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorSalesRevenue?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function getModRuvnlBidSimulationData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function getPriceAnalysisData(
  params: PriceAnalysisParams
): Promise<PriceAnalysisData[]> {
  try {
    const queryParams = new URLSearchParams({
      interval: params.interval,
      price_type: params.price_type,
      exchange_name: params.exchange_name,
      product_name: params.product_name,
    });

    if (params.start_date) {
      queryParams.append("start_date", params.start_date);
    }
    if (params.end_date) {
      queryParams.append("end_date", params.end_date);
    }

    const response = await buildHttpResponse({
      endPoint: `https://api-data.gna.energy/data/price-analysis/?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });

    return response as PriceAnalysisData[];
  } catch (error) {
    console.error("Error fetching price analysis data:", error);
    throw error;
  }
}


export async function getTopBuyerSellerData(
  params: BuyerSellerParams
): Promise<BuyerSellerResponse> {
  try {
    const formData = new FormData();
    formData.append("exchange", params.exchange);
    formData.append("product", params.product);
    formData.append("region", params.region);
    formData.append("start_date", params.start_date);
    formData.append("end_date", params.end_date);

    const response = await buildHttpResponse({
      endPoint: "data/getTopBuyerSeller/",
      method: HttpMethod.POST,
      body: formData,
    });

    return response as BuyerSellerResponse;
  } catch (error) {
    console.error("Error fetching top buyer seller data:", error);
    throw error;
  }
}

export async function getConsumptionData(
  startDate: string,
  endDate: string
): Promise<ConsumptionData[]> {
  const response = await buildHttpResponse({
    endPoint:
      "data/consumption_api?start_date=" + startDate + "&end_date=" + endDate,
    method: HttpMethod.GET,
  });
  const data = response.map((item: any) => ({
    ...item,
    date: item.date,
    energy_met_mu: parseFloat(item.energy_met_mu),
    states: item.states,
  }));
  console.log("Consumption Data = ", data);
  return data;
}

export async function getGenerationData(
  startDate: string,
  endDate: string
): Promise<GenerationData[]> {
  const response = await buildHttpResponse({
    endPoint:
      "data/generation_data_api?start_date=" +
      startDate +
      "&end_date=" +
      endDate,
    method: HttpMethod.GET,
  });

  return response
    .map((item: any) => ({
      ...item,
      date: item.date,
      generation_mu_actual: parseFloat(item.generation_mu_actual),
      states: item.states,
    }))
    .sort(
      (a: any, b: any) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );
}

export async function getCoalStockData(
  startDate: string,
  endDate: string
): Promise<{
  success: boolean;
  data: Array<{
    date: string;
    actual_stock_in_tt_total: number;
    price_rs_per_ton_indian_coal: number | null;
    actual_stock_in_tt_total_prev_year: number;
    price_rs_per_ton_indian_coal_prev_year: number;
  }>;
  count: number;
}> {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/coal-stock-datewise/?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching coal stock data:", error);
    return {
      success: false,
      data: [],
      count: 0,
    };
  }
}
export async function fetchLgbrTableData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/get-lgbr?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchVcGeneratorData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getGeneratorVC?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchLgbrGetData(
  type: string | null,
  time_slot: number | null,
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/get-lgbr-generator?date=${startdate}&session=${session}&type=${type}&time_slot=${time_slot}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getByExchangeData(startDate: string, endDate: string) {
  const response = await buildHttpResponse({
    endPoint: `data/getData/?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getBuyerSellersTrendData(
  formData: FormData
): Promise<any> {
  const response = await buildHttpResponse({
    endPoint: `data/getBuyerSellerTrendData/`,
    method: HttpMethod.POST,
    body: formData,
  });
  return response;
}

export async function getRealTimePrices() {
  const response = await buildHttpResponse({
    endPoint: `data/getRealtimeIexPrices/`,
    method: HttpMethod.GET,
  });

  const transformedData: {
    date: string;
    block: number;
    rate_type: string;
    rate_value: number;
  }[] = [];

  const dates = Object.keys(response);

  for (const date of dates) {
    const dayData = response[date];
    const timeSlots = Object.keys(dayData.DAM_rates);

    timeSlots.forEach((timeSlot, index) => {
      const block = index + 1;

      // Create separate object for DAM
      transformedData.push({
        date: date,
        block: block,
        rate_type: "DAM",
        rate_value: dayData.DAM_rates[timeSlot],
      });

      // Create separate object for GDAM
      transformedData.push({
        date: date,
        block: block,
        rate_type: "GDAM",
        rate_value: dayData.GDAM_rates[timeSlot],
      });

      // Create separate object for RTM
      transformedData.push({
        date: date,
        block: block,
        rate_type: "RTM",
        rate_value: dayData.RTM_rates[timeSlot],
      });
    });
  }

  return transformedData;
}

export async function getExchangeAnalysisData(
  params: ExchangeAnalysisParams
): Promise<ExchangeAnalysisData[]> {
  try {
    const queryParams = new URLSearchParams({
      interval: params.interval,
      price_type: params.price_type,
      exchange_name: params.exchange_name,
      product_name: params.product_name,
    });

    if (params.start_date) {
      queryParams.append("start_date", params.start_date);
    }
    if (params.end_date) {
      queryParams.append("end_date", params.end_date);
    }
    if (params.function) {
      queryParams.append("function", params.function);
    }
    const response = await buildHttpResponse({
      endPoint: `data/exchange-analysis/?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });

    return response as ExchangeAnalysisData[];
  } catch (error) {
    console.error("Error fetching exchange analysis data:", error);
    throw error;
  }
}

//Entity Analysis Api in Exchange tab in HPPC

export async function getEntityComparisonV2({
  entityid,
  exchangeName,
  productName,
  startDate,
  endDate,
  function: functionType = "cumulative",
}: {
  entityid: number;
  exchangeName: string;
  productName: string;
  startDate: string;
  endDate: string;
  function?: "cumulative" | "comparative";
}): Promise<any[]> {
  const response = await fetch(
    `https://api-data.gna.energy/data/getSlotWiseAggregatedEntityDataV2/?exchange_name=${exchangeName}&product_name=${productName}&start_date=${startDate}&end_date=${endDate}&function=${functionType}&entitity_id=${entityid}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();
  return data.data as any[];
}

export async function getBuyerSellersData(formData: FormData): Promise<any> {
  const response = await buildHttpResponse({
    endPoint: `data/getTopBuyerSeller/`,
    method: HttpMethod.POST,
    body: formData,
  });
  return response;
}
export async function getHaryanaGenerationProfile(
  startDate: string,
  endDate: string,
  sourcesParam: string = ''
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getGenerationProfile?start_date=${startDate}&end_date=${endDate}${sourcesParam}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    return res;
  } catch (error) {
    console.error("Error fetching Haryana Generation Profile data:", error);
    return [];
  }
}
